import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const servicosPrevencao = [
    'Projetos AVCB e CLCB',
    'Regularização Bombeiros',
    'Consultoria em Incêndio',
    'Treinamento de Brigada',
    'Laudos Elétricos',
  ];

  const servicosSeguranca = [
    'Elaboração de PGR',
    'LTCAT',
    'Laudos de Insalubridade',
    'PPP',
    'Treinamentos NRs',
  ];

  const servicosAvaliacoes = [
    'Perícias Técnicas',
    'Assistência Judicial',
    'Avaliações de Imóveis',
    'Laudos Especializados',
    'Pareceres Técnicos',
  ];

  const navegacao = [
    { nome: 'Institucional', link: '/institucional' },
    { nome: 'Serviços', link: '/servicos' },
    { nome: 'Treinamentos', link: '/treinamentos' },
    { nome: 'Blog', link: '/blog' },
    { nome: 'FAQ', link: '/faq' },
    { nome: 'Contato', link: '/contato' },
  ];

  return (
    <footer className="bg-[#0D0D0D] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Logo e Descrição */}
          <div className="lg:col-span-4">
            <div className="inline-block mb-6">
              <img
                src="https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/249d59af90f80da46e7dcb343077579c.png"
                alt="Engeporto Engenharia"
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6 max-w-[320px]">
              Autoridade técnica em engenharia especializada, oferecendo soluções completas em prevenção de incêndio, segurança do trabalho e perícias técnicas.
            </p>

            {/* CREA-SP */}
            <div className="mb-6">
              <div className="flex items-center gap-2">
                <img
                  src="https://static.readdy.ai/image/c4e06bad978995a8efa8373b87e2590a/67ab712f1d949d9d0e8df825c6e65a10.png"
                  alt="CREA-SP Registro Nº 2511699"
                  className="h-10 w-auto object-contain"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              </div>
            </div>

            <div className="flex items-center gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-full hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-full hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-neutral-700 rounded-full hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Navegação e Serviços */}
          <div className="lg:col-span-5 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-white font-semibold text-sm mb-4">
                Navegação
              </h4>
              <ul className="space-y-2.5">
                {navegacao.map((item) => (
                  <li key={item.nome}>
                    <Link
                      to={item.link}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      className="text-sm text-neutral-400 hover:text-[#D4AF37] transition-colors"
                    >
                      {item.nome}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">
                Prevenção de Incêndio
              </h4>
              <ul className="space-y-2.5">
                {servicosPrevencao.map((servico) => (
                  <li key={servico}>
                    <Link
                      to="/servicos/prevencao-incendio"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      className="text-sm text-neutral-400 hover:text-[#D4AF37] transition-colors"
                    >
                      {servico}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">
                Segurança do Trabalho
              </h4>
              <ul className="space-y-2.5">
                {servicosSeguranca.map((servico) => (
                  <li key={servico}>
                    <Link
                      to="/servicos/seguranca-trabalho"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      className="text-sm text-neutral-400 hover:text-[#D4AF37] transition-colors"
                    >
                      {servico}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contato */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold text-sm mb-4">
              Contato
            </h4>
            <div className="space-y-4">
              <div>
                <p className="text-xs text-neutral-500 mb-1.5">
                  Regiões de Atendimento
                </p>
                <p className="text-sm text-neutral-300 leading-relaxed">
                  Região Metropolitana de Sorocaba<br />
                  Região Metropolitana de Campinas
                </p>
              </div>
              <div>
                <p className="text-xs text-neutral-500 mb-1.5">
                  Telefone
                </p>
                <a href="tel:+5515996719308" className="text-base text-white font-medium hover:text-[#D4AF37] transition-colors">
                  (15) 99671-9308
                </a>
              </div>
              <div>
                <p className="text-xs text-neutral-500 mb-1.5">
                  E-mail
                </p>
                <a href="mailto:engeporto.contato@gmail.com" className="text-sm text-neutral-300 hover:text-[#D4AF37] transition-colors break-all">
                  engeporto.contato@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Linha Divisória e Copyright */}
        <div className="border-t border-neutral-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-neutral-500">
            © {currentYear} Engeporto Engenharia e Serviços Ltda. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/politica-privacidade"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-sm text-neutral-500 hover:text-[#D4AF37] transition-colors"
            >
              Política de Privacidade
            </Link>
            <Link
              to="/termos-uso"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-sm text-neutral-500 hover:text-[#D4AF37] transition-colors"
            >
              Termos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;